<template>
  <div class="py-2 px-6" v-if="totalCounts > 0">
  <nav class="block">
    <ul class="flex pl-0 rounded list-none flex-wrap">
      <li>
        <a href="#pablo" class="first:ml-0 text-xs font-semibold flex w-8 h-8 mx-1 p-0 rounded-full items-center justify-center leading-tight relative border border-solid border-emerald-500 bg-white text-emerald-500">
          <i class="fas fa-chevron-left -ml-px"></i>
          <i class="fas fa-chevron-left -ml-px"></i>
        </a>
      </li>
      <li>
        <a href="#pablo" class="first:ml-0 text-xs font-semibold flex w-8 h-8 mx-1 p-0 rounded-full items-center justify-center leading-tight relative border border-solid border-emerald-500 bg-white text-emerald-500">
          <i class="fas fa-chevron-left -ml-px"></i>
        </a>
      </li>
      <li
        v-for="index in visiblePages"
        :key="index"
        
      >
        <a href="#" 
        class="first:ml-0 text-xs font-semibold flex w-8 h-8 mx-1 p-0 rounded-full items-center justify-center leading-tight relative border border-solid border-emerald-500"
        v-bind:class="{'bg-white': (currentPage != index), 'text-white': (currentPage == index), 'bg-emerald-500': (currentPage == index), 'text-emerald-500': (currentPage != index)}"
        v-on:click="handlePageChange(index)"
        >
          {{ index }}
        </a>
      </li>
     
      <li>
        <a href="#pablo" class="first:ml-0 text-xs font-semibold flex w-8 h-8 mx-1 p-0 rounded-full items-center justify-center leading-tight relative border border-solid border-emerald-500 bg-white text-emerald-500">
          <i class="fas fa-chevron-right -mr-px"></i>
        </a>
      </li>
      <li>
        <a href="#pablo" class="first:ml-0 text-xs font-semibold flex w-8 h-8 mx-1 p-0 rounded-full items-center justify-center leading-tight relative border border-solid border-emerald-500 bg-white text-emerald-500">
          <i class="fas fa-chevron-right -mr-px"></i>
          <i class="fas fa-chevron-right -mr-px"></i>
        </a>
      </li>
    </ul>
  </nav>
</div>
</template>

<script>

import constants from "@/constants"
export default {
  data() {
    return {
      currentPage: 1,
      visiblePages: Math.ceil(this.totalCounts/this.perPage),
    };
  },
  props: {
    totalCounts: {type: Number, default: 1},
    perPage: {type: Number, default: constants.pageLimit},
    onPageChange: {type: Function}
  },
  methods: {
    handlePageChange(value) {
      this.currentPage = value
      this.onPageChange(value)
    },
  },
  watch: { 
    totalCounts: function(newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      var val = Math.ceil(newVal/this.perPage)
      if(this.perPage >= newVal){
        val = 1
      }else{
        val = (val > 5 ? 5 : val)
      }
      
      this.visiblePages = val
    }
  },
  components: {
    
  },
};
</script>
